"use strict";

import React, {Component} from 'react';
import { NavLink, withRouter } from "react-router-dom";
import {FilterSelectors} from "../../context/FilterContext";

const Header = withRouter(class Header extends Component {

    constructor(props) {
        super(props);
    }

    getNavLinkClass(path) {
        return this.props.location.pathname === path ? 'active' : '';
    }

    renderRoute(route) {
        return route.headerRoute
               ? <li key={route.path} className={this.getNavLinkClass(route.path)}>
                     <NavLink key={route.path} exact={route.exact} to={route.path}>{route.label}</NavLink>
                 </li>
               : null;

    }

    render() {
        return (
                <header className="main-header">
                    {/* Header Navbar */}
                    <div className="navbar-header">
                        {/* Logo */}
                        <NavLink to="/" className="logo">
                            {/* mini logo for sidebar mini 50x50 pixels */}
                            <span className="logo-mini">VE<b>I</b></span>
                            {/* logo for regular state and mobile devices */}
                            <span className="logo-lg">VE<b>Insights</b></span>
                        </NavLink>
                    </div>
                    <nav className="navbar navbar-static-top" role="navigation">
                        {/* Navbar Left Menu */}
{/*
                        <div className="navbar-collapse pull-left collapse">
                            <ul className="nav navbar-nav">
                                { this.props.routes.map(route => this.renderRoute(route)) }
                            </ul>
                        </div>
*/}
                        {/* Navbar Right Menu */}
                        <div className="navbar-custom-menu">
                            <FilterSelectors />
                        </div>
                    </nav>
                </header>
        )
    }
});

export default Header;
